import { render, staticRenderFns } from "./ServiceTypeEdit.vue?vue&type=template&id=53b4ae30&scoped=true"
import script from "./ServiceTypeEdit.vue?vue&type=script&lang=ts"
export * from "./ServiceTypeEdit.vue?vue&type=script&lang=ts"
import style0 from "./ServiceTypeEdit.vue?vue&type=style&index=0&id=53b4ae30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4ae30",
  null
  
)

export default component.exports